"use strict";
/* globals module */
/**
 * @module commerceCountryStateClient
 * @description  Commerce Country State Client provides an easy way to consume  Commerce REST API end-points. In order to obtain a needed routes `commerceCountryStateClient` uses `commerceCountryStateRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../../../httpApi");
var __1 = require("../../");
var CommerceLookupsCountryStateClient = /** @class */ (function () {
    function CommerceLookupsCountryStateClient(commerceLookupsCountryStateRoute, commerceLookupsCountryStateBatchClient, apiClient) {
        this.commerceLookupsCountryStateRoute = commerceLookupsCountryStateRoute;
        this.commerceLookupsCountryStateBatchClient = commerceLookupsCountryStateBatchClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceLookupsCountryStateClient.prototype, "routeDefinition", {
        get: function () {
            return this.commerceLookupsCountryStateRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommerceLookupsCountryStateClient.prototype, "batch", {
        get: function () {
            return this.commerceLookupsCountryStateBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of commerce resources matching the given criteria.
     * @method
     * @example commerceLookupsCountryStateClient.find({
                    countryId: '<country-id>'
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    CommerceLookupsCountryStateClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the commerce resource.
     * @method
     * @example commerceLookupsCountryStateClient.get('<state-id>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CommerceLookupsCountryStateClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.commerceLookupsCountryStateRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create commerce action has been performed; this action creates a new commerce resource.
     * @method
     * @example commerceLookupsCountryStateClient.create({
                      countryId : '<country-id>',
                      name: '<name>',
                      abrv: '<abrv>',
                      description: '<description>'
                  })
                  .then(function (data) {
                      // perform success action here
                  },
                   function (response, status, headers, config) {
                       // perform error handling here
                  });
   **/
    CommerceLookupsCountryStateClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update commerce action has been performed; this action updates a commerce resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commerceLookupsCountryStateRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commerceCountryState);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @example // commerceCountryState is a resource previously fetched using get action.
                    commerceCountryState.description = '<description>';
                    commerceLookupsCountryStateClient.update(commerceCountryState)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    CommerceLookupsCountryStateClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a commerce resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commerceLookupsCountryStateRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commerceCountryState);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @example // commerceCountryState is a resource previously fetched using get action.
                   commerceLookupsCountryStateClient.remove(commerceCountryState)
                       .then(function (data) {
                           // perform success action here
                       },
                        function (response, status, headers, config) {
                            // perform error handling here
                       });
    **/
    CommerceLookupsCountryStateClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b, _c;
    CommerceLookupsCountryStateClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceLookupsCountryStateRoute)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.CommerceLookupsCountryStateBatchClient)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceLookupsCountryStateRoute !== "undefined" && __1.CommerceLookupsCountryStateRoute) === "function" ? _a : Object, typeof (_b = typeof __1.CommerceLookupsCountryStateBatchClient !== "undefined" && __1.CommerceLookupsCountryStateBatchClient) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], CommerceLookupsCountryStateClient);
    return CommerceLookupsCountryStateClient;
}());
exports.CommerceLookupsCountryStateClient = CommerceLookupsCountryStateClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 
